import type { MethodConfig } from "../schema/master";

/**
 * 산정방식 규칙.
 *
 * ⚠️ 인증제 값(순도 조건,등급,범위)은 「청정수소 인증제도 운영에 관한 고시」와 인증운영기관 자료로
 *    확정해야 한다. 아래는 공개 자료로 잡은 임시안이며 KTR 검토 후 교체한다.
 */
export const METHOD_CONFIGS: MethodConfig[] = [
  {
    id: "general",
    label: "일반 LCA 기반 산정",
    description:
      "KS I ISO 14040 및 14044의 절차와 ISO 14067의 원칙을 적용하고, ISO 19870 계열의 수소 온실가스 산정방법을 참고한다. 산정목적에 따라 기능단위 세부조건과 시스템 경계를 사용자가 설정한다.",
    standards: ["KS I ISO 14040:2006", "KS I ISO 14044:2006", "ISO 14067:2018", "ISO 19870:2023 (참고)"],
    gwp: { basis: "IPCC 제5차 평가보고서(AR5) 100년", co2: 1, ch4: 28, n2o: 265 },
    functionalUnit: { locked: false, h2Kg: 1 },
    boundary: {
      locked: false,
      description: "사용자가 산정목적에 따라 설비별 포함과 제외를 정한다. 저장 및 이송 손실을 반영한 최종 인도 수소량을 분모로 쓴다.",
      includeLocations: ["upstream", "onsite", "downstream"],
    },
    denominator: "delivered",
    notices: [
      "본 프로그램은 기후변화 영향범주(온실가스)만 다루며, 산성화, 부영양화 등 다른 환경영향범주는 산정대상이 아닙니다.",
      "산정결과는 모의산정 결과로서 종합적인 환경영향평가, 제3자 검증 또는 청정수소 인증기관의 공식 판정을 대체하지 않습니다.",
    ],
  },
  {
    id: "cert",
    label: "청정수소 인증제 모의산정",
    description:
      "국내 청정수소 인증제가 정한 기능단위, 시스템 경계, 주요 계산조건을 적용한다. 원료 조달부터 생산시설 출하지점까지(Well-to-Gate)를 산정하며, 출하 이후의 저장 및 이송은 결과에서 제외한다.",
    standards: ["청정수소 인증제도 운영에 관한 고시(산업통상자원부 고시, 2024-03-04 제정)", "ISO 19870 계열 (참고)"],
    gwp: { basis: "IPCC 제5차 평가보고서(AR5) 100년 (인증제 별도 규정 시 그에 따름, 확인 필요)", co2: 1, ch4: 28, n2o: 265 },
    functionalUnit: { locked: true, h2Kg: 1, purityMinPct: 99.97, deliveryPoint: "생산시설 출하지점" },
    boundary: {
      locked: true,
      description: "원료의 저장 및 수송과 생산시설 내부의 저장 및 이송은 포함하고, 생산시설 출하 이후의 수소 저장 및 이송은 제외한다.",
      includeLocations: ["upstream", "onsite"],
    },
    denominator: "gate",
    grades: [
      { grade: 1, maxKgCO2eq: 0.1 },
      { grade: 2, maxKgCO2eq: 1.0 },
      { grade: 3, maxKgCO2eq: 2.0 },
      { grade: 4, maxKgCO2eq: 4.0 },
    ],
    thresholdKgCO2eq: 4.0,
    notices: [
      "청정수소 인증제의 재생에너지 인정조건은 단순화하여 적용합니다(재생에너지 전력의 배출계수를 0 으로 봄).",
      "출하 이후의 손실량은 반영하지 않으며, 생산시설 출하지점의 수소량을 기준으로 기능단위당 배출량을 산정합니다.",
      "수소 순도 적용조건(임시: 99.97% 이상)은 인증운영기관 자료로 확정 예정입니다.",
      "산정결과는 모의산정 결과로서 청정수소 인증기관의 공식 판정을 대체하지 않습니다.",
    ],
  },
];
